import { API } from '@/shared/plugins/Api/API'

class Domains extends API {
  constructor () {
    super('FPAPI', true)
  }

  async list (dataplantId, appName) {
    return this.request({
      method: 'GET',
      url: `/dataplant/${dataplantId}/${appName}/domains`
    })
  }

  async create (dataplantId, appName, body) {
    return this.request({
      method: 'POST',
      url: `/dataplant/${dataplantId}/${appName}/domains`,
      data: body
    })
  }

  async delete (dataplantId, appName, domainId) {
    return this.request({
      method: 'DELETE',
      url: `/dataplant/${dataplantId}/${appName}/domains/${domainId}`
    })
  }
}

export default Domains
